<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="main" *ngIf="!isLoading">
  <div class="titulo">
    <p>Tabela de origem: TACO</p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()">close</mat-icon>
  </div>

  <hr />

  <div class="conteudo">
    <mat-form-field appearance="outline" class="buscar">
      <mat-label>Buscar por nome do alimento</mat-label>
      <img
        matPrefix
        src="../../../../../../assets/svg/icons/search.svg"
        alt="Lupa"
        class="icone"
      />
      <input
        matInput
        type="text"
        (input)="buscarPorNome($event)"
      />
    </mat-form-field>

    <div class="container-tabela">
      <table mat-table [dataSource]="alimentos" matSort class="cis-default-table">
        <ng-container matColumnDef="descricaoAlimento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Alimento</th>
          <td mat-cell *matCellDef="let alimento" (click)="onSelect(alimento)">{{ alimento.descricaoAlimento }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <button
      class="rascunho-btn"
      (click)="inserirManualmente()"
    >
      Inserir manualmente
    </button>
  </div>
</div>
